import React from 'react';
import ReactDOM from 'react-dom';
export function renderer(_a) {
    var App = _a.App, appConfig = _a.appConfig, ssrRenderer = _a.ssrRenderer, hasServerCompiler = _a.hasServerCompiler, rootElement = _a.rootElement;
    var renderDOM = function () {
        var root = rootElement ||
            ((appConfig === null || appConfig === void 0 ? void 0 : appConfig.rootElementId) ? document.getElementById(appConfig.rootElementId) : document.getElementById('root'));
        if (hasServerCompiler) {
            ssrRenderer(App, function () { return null; }, rootElement || 'root');
            return;
        }
        ReactDOM.render(React.createElement(App, null), root);
    };
    // 兼容 0.5.x 逻辑
    if (appConfig === null || appConfig === void 0 ? void 0 : appConfig.render) {
        // eslint-disable-next-line
        appConfig.render(renderDOM);
        return;
    }
    renderDOM();
    var afterRender = appConfig.afterRender;
    afterRender();
}
//# sourceMappingURL=renderer.js.map